import router from "next/router";
import Offers from "../elements/Offers";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import { FaThumbsUp } from "react-icons/fa";
import { connect } from "react-redux";
import { resetCart, saveCart } from "../../../lib/cart";
import { gtmChooseWorkShop } from "../../../lib/google-tag-manager";
import {
  getCategory,
  getVariants,
  getWorkshopsAddonByVariant,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../../redux/actions/apiActions";
import {
  AppliedCartOffers,
  addToCart,
  setCartAddedPackages,
  setCartJobItems,
  setCartProducts,
  setCartStage,
  setCartWorkshop,
  setShowMobileIstand,
  updateCartItems,
} from "../../../redux/actions/cartAction";
import WorkshopStars from "../../common/WorkshopStars";
import WorkshopTime from "../../common/WorkshopTime";
import { checkWorkshopAvailability } from "../../../lib/workshop";
import { setLayer } from "../../../redux/actions/globalAction";
import API from "api";
import { workshopSelection } from "actions/Cart";
import { isMobile } from "react-device-detect";
import toast from "react-hot-toast";
import ResetCartPopup from "components/common/ResetCartPopup";
import { useRef } from "react";

const WorkshopDataItem = ({
  id,
  getWorkshopsProductCategory,
  getWorkshopsJourneyVariant,
  globalData,
  getWorkshopsAddonByVariant,
  setShow,
  apiData,
  setCartStage,
  setCartWorkshop,
  cart,
  setCartJobItems,
  getCategory,
  item,
  index,
  key,
  updateCartItems,
  getVariants,
  setShowMobileIstand,
  setCartAddedPackages,
  AppliedCartOffers,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(null);
  const [isWorkshopAvailable, setIsWorkshopAvailable] = useState(false);
  const [changeOfferModalShow, setChangeOfferModalShow] = useState(false);
  const [showpopup, setShowPopup] = useState(false);
  const [selectOffer, setSelectOffer] = useState([]);
  const [showWarnig, setShowWarnig] = useState(false);
  const [discountValue, setDiscountValue] = useState(0);
  const { products } = cart;

  const PopupRef = useRef();

  const handleOutsideClick = (event) => {
    if (PopupRef.current && !PopupRef.current.contains(event.target)) {
      setShowPopup(false);
    }
  };
  useEffect(() => {
    if (showpopup) {
      document.addEventListener("mouseup", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mouseup", handleOutsideClick);
    };
  }, [showpopup]);

  useEffect(() => {
    if (cart.jobItems.length > 0 && cart.workshop?.Id == item.Id) {
      saveCart(cart, apiData, globalData);
    }
  }, [cart.jobItems]);

  useEffect(() => {
    const response = checkWorkshopAvailability(item);
    setIsWorkshopAvailable(response);
  }, []);

  const workShopNavigate = (value) => {
    const carData = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );
    let carSlug =
      carData && carData.slug
        ? carData.slug
        : `${carData.brand} ${carData.modal}`
            .trim()
            .split(" ")
            .join("-")
            .toLowerCase()
            .split(".")
            .join("");
    let immutableUrl = "/";
    if (router.query.slug) {
      router.query.slug.map((item, index) => {
        immutableUrl += index == 3 ? value.Slug : item;
        immutableUrl += "/";
        return item;
      });
      if (router.query.slug.length < 3) {
        immutableUrl += `${carSlug}/${value.Slug}`;
      }
      if (router.query.slug.length == 3) {
        immutableUrl += value.Slug;
      }
    }
    immutableUrl += `?id=1`;
    router.push(
      {
        pathname: `/services/[...slug]`,
      },
      `/services/${immutableUrl}`,
      { shallow: true }
    );
  };

  const selectWorkshop = async (item) => {
    if (discountValue) {
      AppliedCartOffers({
        ...cart.appliedCartOffers,
        isOfferWorkshopSelected: true,
      });
    }
    const isWorkshopCollection = sessionStorage.getItem("isWorkshopCollection");
    if (!isWorkshopCollection) {
      localStorage.setItem("isFirstJourneySteps", true);
    }
    localStorage.removeItem("isSmartSelection");

    if (router.query.slug && router.query.slug[1] == "tyre") {
      setIsSubmitting(item.Id);

      let jobs = [];
      await Promise.all(
        products?.map(async (variant) => {
          try {
            setShow(false);
            setCartWorkshop(item);
            jobs.push(variant);

            // workShopNavigate(item);
          } catch (error) {
            console.log("Error", error);
          }
        })
      );
      setCartJobItems([...jobs]);
      setCartStage(2);
      setIsSubmitting(null);
      //   workShopNavigate(item);
      return;
    }

    gtmChooseWorkShop(item.Name);
    setIsSubmitting(item.Id);
    let brandId = null;
    if (products.length == 0) {
      getWorkshopsJourneyVariant(item.Id, id, mId);
      setShow(false);
      setCartWorkshop(item);
      let vId = JSON.parse(localStorage.getItem("product-id"));
      brandId = JSON.parse(
        localStorage.getItem("brand-id") || JSON.stringify("{}")
      );
      let mId = globalData.carData?.modelId;
      getWorkshopsAddonByVariant(item.Id, vId);

      getWorkshopsProductCategory(item.Id, mId);
      setCartStage(2);
      setIsSubmitting(null);
      workShopNavigate(item);
      return;
    }

    let jobs = [];
    await Promise.all(
      products?.map(async (variant) => {
        try {
          const res = await workshopSelection(
            item?.Id,
            variant.Id,
            globalData.carData?.modelId,
            brandId
          );
          if (res.err) {
            showLoader(false);
            return;
          }
          setShow(false);
          setCartWorkshop(item);
          jobs.push(res.Data[0]);
          let vId = JSON.parse(localStorage.getItem("product-id"));
          let mId = globalData.carData?.modelId;
          getWorkshopsAddonByVariant(item.Id, vId);
          getWorkshopsJourneyVariant(item.Id, id, mId);

          getWorkshopsProductCategory(item.Id, mId);
          workShopNavigate(item);
        } catch (error) {
          console.log("Error", error);
        }
      })
    );
    setCartJobItems([...jobs]);
    setCartStage(2);
    setIsSubmitting(null);
    workShopNavigate(item);
  };

  const handleResetCart = (loading) => {
    setCartStage(null);
    setCartProducts([]);
    setCartJobItems([]);
    if (!sessionStorage.getItem("isWorkshopCollection")) setCartWorkshop(null);
    setCartAddedPackages([]);
    setLayer(false);
    saveCart(cart, apiData, globalData, true);
    resetCart()
      .then((res) => {
        localStorage.setItem("hasLocationPermission", "granted");
        if (router.query?.slug) {
          router.push(
            {
              pathname: `/services/[...slug]`,
            },
            `/services/${
              globalData.locationData?.data.EmirateAreaSlug || "dubai"
            }/${router.query?.slug[1] ? router.query?.slug[1] : ""}${
              router.query.slug[2] ? "/" + router.query?.slug[2] : ""
            }`,
            { shallow: true }
          );
          setShowMobileIstand(false);
          loading(false);
          handleClose();
        }
      })
      .catch((err) => {
        loading(false);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      });
  };

  const handleConfirmReset = (loading) => {
    setCartWorkshop(null);
    sessionStorage.removeItem("get-fitting-at-home");
    localStorage.removeItem("isSmartSelection");
    getCategory();
    // const products = cart.products.length ? cart.products?.slice(0, 1) : [];
    updateCartItems([], []);
    getVariants(id, globalData?.carData?.modelId);
    handleResetCart(loading);
  };

  const handleClose = () => {
    setShowWarnig(false);
  };

  const removeWorkshop = () => {
    setShowWarnig(true);
  };

  const handleOffers = (offer) => {
    setChangeOfferModalShow(true);
    setSelectOffer(offer);
  };

  const handleDiscountPrice = (item) => {
    if (cart.appliedCartOffers) {
      const offer = item.Offers
        ? item.Offers.find((e) => {
            return e?.PromotionId === cart?.appliedCartOffers?.PromotionId;
          })
        : null;
      const filterData = offer ? offer : null;
      if (filterData) {
        const cost = parseFloat(item?.Cost);
        const discountPercentage = cart?.appliedCartOffers
          ?.PromotionPercentValue
          ? parseFloat(cart?.appliedCartOffers?.PromotionPercentValue)
          : 0;
        const d_amount = (cost * discountPercentage) / 100;
        const flatvalue = parseFloat(
          cart?.appliedCartOffers?.PromotionFlatValue
            ? cart?.appliedCartOffers?.PromotionFlatValue
            : 0
        );
        const remainingValue = cost - d_amount - flatvalue;
        setDiscountValue(parseFloat(remainingValue).toFixed(2));
      }
    }
  };
  useEffect(() => {
    handleDiscountPrice(item);
  }, [item, cart.appliedCartOffers]);

  return (
    <li>
      <ResetCartPopup
        show={showWarnig}
        onHide={handleClose}
        handleResetCart={handleConfirmReset}
      />
      <div className="workshop-block-island-list">
        <div className="workshop-block-island-list-t1">
          {changeOfferModalShow ? (
            <Offers
              setChangeOfferModalShow={setChangeOfferModalShow}
              changeOfferModalShow={changeOfferModalShow}
              offers={selectOffer}
            />
          ) : null}
          <div className="workshop-block-islandlf w-100">
            <small className="block-islandlf-lgo">
              <img src={item.LogoUrl} />
            </small>
            <div
              className="garage-ws-lft"
              style={{ width: isMobile && "calc(100% - 60px)" }}
            >
              <div className="d-flex justify-content-between">
                <h3>{item.Name}</h3>
                {isMobile && item?.IsObChoice && (
                  <div className="sm-layerasr smly-mob">
                    <small className="glareanimationee">
                      <img
                        src="/assets/workshop-detail/choice-icon.svg"
                        alt="choice-icon"
                      />
                      <span>OB CHOICE</span>
                    </small>
                  </div>
                )}
              </div>

              {isMobile ? (
                <span></span>
              ) : (
                <div className="sm-layerasr mt-1">
                  {item?.IsObChoice ? (
                    <small className="glareanimationee ">
                      <img
                        src="/assets/workshop-detail/choice-icon.svg"
                        alt="choice-icon"
                      />
                      <span>OB CHOICE</span>
                    </small>
                  ) : null}
                  {item.Offer ? (
                    <label
                      className="offr-labels-island offer_island"
                      onClick={() => handleOffers(item)}
                      style={{ width: "200px" }}
                    >
                      <img src="/assets/products/party-icon.webp" /> 3 Offer
                      Available
                    </label>
                  ) : null}
                </div>
              )}

              <label>
                <span>{`${item.AreaName}, ${item.EmirateName}`}</span>
                <i>{parseFloat(item.Distance).toFixed(2)} KM away</i>
              </label>
              <span>
                <strong>Open</strong>- Closes 7:00 PM
                {isMobile ? (
                  <div className="rating-wrs-right rating-wrs-mob">
                    <div className="star-rating">
                      <div className="back-stars">
                        <WorkshopStars rating={item.GoogleRating} />
                      </div>
                    </div>
                    <span>({item.GoogleRating})</span>
                  </div>
                ) : (
                  <span></span>
                )}
              </span>

              {isMobile ? (
                <div className="sm-layerasr smly-mob">
                  {/* <small className="glareanimationee">
                    <img
                      src="/assets/workshop-detail/choice-icon.svg"
                      alt="choice-icon"
                    />
                    <span>OB CHOICE</span>
                  </small> */}
                  {discountValue ? (
                    <label className="offr-labels-island">
                      <img src="/assets/products/party-icon.webp" />
                      Offers Applied
                    </label>
                  ) : null}
                </div>
              ) : (
                <span></span>
              )}
            </div>
            {isMobile ? (
              <></>
            ) : (
              <div className="sm-layerasr mt-1">
                {item?.IsObChoice ? (
                  <small className="glareanimationee">
                    <img
                      src="/assets/workshop-detail/choice-icon.svg"
                      alt="choice-icon"
                    />
                    <span>OB CHOICE</span>
                  </small>
                ) : null}
              </div>
            )}
          </div>
          {isMobile ? (
            <span></span>
          ) : (
            <>
              <div className="rating-wrs-right">
                <div className="star-rating">
                  <div className="back-stars">
                    <WorkshopStars rating={item.GoogleRating} />
                  </div>
                </div>
                <span>({item.GoogleRating})</span>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="amenities-list-sdbar">
        <ul>
          {item?.Amenities && item?.Amenities?.length
            ? item.Amenities?.slice(0, 3).map((item, index) => {
                return (
                  <li>
                    <span>
                      <img src={item.ImgUrl} />
                      <i>{item.Name}</i>
                    </span>
                  </li>
                );
              })
            : null}

          {item?.Amenities?.length > 3 ? (
            <li
              className="more-item-amenties"
              onClick={() => {
                setShowPopup(!showpopup);
              }}
            >
              <label>+{item?.Amenities?.length - 3}</label>
              {showpopup ? (
                <div
                  ref={PopupRef}
                  className="workshop-block-island-ul drp-list-amn"
                  style={{ width: "150px", zIndex: 999 }}
                  // aria-labelledby="dropdownMenuamenties"
                >
                  <ul
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {item?.Amenities.slice(3).map((item, index) => {
                      return (
                        <li className="p-1">
                          <span>
                            <img src={item.ImgUrl} />
                            <i>{item.Name}</i>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </li>
          ) : null}
        </ul>
      </div>
      <div className="action-bard-island-wrk">
        <label>
          <img
            src="/assets/workshop-detail/90days.svg"
            className="labor-icon-webshow"
          />
          <span>90 Days Labor Warranty</span>
        </label>
        <div className="rightpr-label-block">
          {isWorkshopAvailable ? (
            <>
              <span className="d-flex align-items-center workshop-price-difference mx-2">
                {isWorkshopAvailable}
              </span>
              <span className="d-flex align-items-center workshop-price-difference-low mx-2">
                AED {parseFloat(item.Cost).toFixed(2)}
              </span>
            </>
          ) : parseFloat(item.Cost) >
            parseFloat(JSON.parse(localStorage.getItem("product-amount"))) ? (
            <span className="d-flex align-items-center workshop-price-difference mx-1 higher-price-label">{`+ AED ${parseFloat(
              parseFloat(item.Cost) -
                parseFloat(JSON.parse(localStorage.getItem("product-amount")))
            ).toFixed(2)} Higher Price`}</span>
          ) : (
            <>
              <div className="prc-label-wps d-flex">
                {discountValue ? (
                  <>
                    <span className="d-flex align-items-center workshop-price-difference-low-del  mx-1">
                      AED{" "}
                      <del
                        style={{
                          fontWeight: 300,
                          opacity: 0.8,
                          marginLeft: "4px",
                        }}
                      >
                        {" "}
                        {parseFloat(item.Cost).toFixed(2)}
                      </del>
                    </span>
                    <span
                      className="d-flex align-items-center workshop-price-difference-low mx-1"
                      style={{ color: "#000" }}
                    >
                      {parseFloat(discountValue).toFixed(2)}
                    </span>
                  </>
                ) : (
                  <span
                    className="d-flex align-items-center workshop-price-difference-low mx-1"
                    style={{ color: "#000" }}
                  >
                    AED {parseFloat(item.Cost).toFixed(2)}
                  </span>
                )}
              </div>
            </>
          )}
          {item.Id === cart.workshop?.Id ? (
            <button
              onClick={() => removeWorkshop()}
              className="workshop-button-one workshop-select-btn bg-yellow"
              style={{ fontSize: 12, padding: "12px 26px" }}
            >
              Remove
            </button>
          ) : (
            <button
              onClick={() => selectWorkshop(item)}
              className={
                "workshop-button-one workshop-select-btn workshop- glare-animation" +
                index
              }
              style={{ fontSize: 12 }}
              disabled={isSubmitting == item.Id}
            >
              Select{" "}
              {isSubmitting == item.Id && (
                <Spinner
                  animation="grow"
                  role="status"
                  className="ml-2"
                  size="sm"
                >
                  <span className="visually-hidden"></span>
                </Spinner>
              )}
            </button>
          )}
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    apiData: state.apiData,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWorkshopsAddonByVariant: (id, vId) => {
      dispatch(getWorkshopsAddonByVariant(id, vId));
    },
    getWorkshopsJourneyVariant: (id, cId, mId) => {
      dispatch(getWorkshopsJourneyVariant(id, cId, mId));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setCartJobItems: (data) => {
      dispatch(setCartJobItems(data));
    },
    addToCart: (workshopId, variant, carModeId) => {
      dispatch(addToCart(workshopId, variant, carModeId));
    },
    getCategory: () => {
      dispatch(getCategory());
    },
    setCartProducts: (data) => {
      dispatch(setCartProducts(data));
    },
    updateCartItems: (jobItems, products) => {
      dispatch(updateCartItems(jobItems, products));
    },
    getVariants: (id, mId, WId) => {
      dispatch(getVariants(id, mId, WId));
    },
    setCartAddedPackages: (packages) => {
      dispatch(setCartAddedPackages(packages));
    },
    setShowMobileIstand: (packages) => {
      dispatch(setShowMobileIstand(packages));
    },
    AppliedCartOffers: (data) => {
      dispatch(AppliedCartOffers(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkshopDataItem);
